import type { FunctionComponent, MouseEvent } from 'react';

import { Backdrop, CloseButton, Container, Header, Inner } from './styles';
import type { Props } from './types';
import { ModalSize } from './types';

const Modal: FunctionComponent<Props> = ({
    children,
    title = false,
    onCloseHandler,
    size = ModalSize.default,
}: Props) => {
    const onContainerClick = (event: MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onCloseHandler();
        }
    };

    return (
        <>
            <Container onClick={onContainerClick}>
                <Inner size={size}>
                    <Header>
                        {title}
                        <CloseButton onClick={onCloseHandler}>×</CloseButton>
                    </Header>

                    {children}
                </Inner>
            </Container>

            <Backdrop />
        </>
    );
};

export default Modal;
